import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import axios from "axios";
import url from "../../function/url";

function PremiumMembershipManagerEmployee() {
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [telecallers, setTelecallers] = useState({});
  const [telecallerOptions, setTelecallerOptions] = useState([]);

  useEffect(() => {
    fetchEmployees(`${url.path}/premiumManageremployees/`);
    fetchTelecallers();
  }, []);

  const fetchEmployees = async (apiUrl) => {
    try {
      const response = await axios.get(apiUrl);
      console.log(response.data);

      const employeesData =
        response.data.employees?.results || response.data.employees || [];

      setEmployees(employeesData);
      setFilteredEmployees(employeesData);

      const initialTelecallers = {};
      employeesData.forEach((emp) => {
        initialTelecallers[emp.id] = "";
      });
      setTelecallers(initialTelecallers);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const fetchTelecallers = async () => {
    try {
      const response = await axios.get(`${url.path}/getTelecallers/`);
      setTelecallerOptions(response.data);
    } catch (error) {
      console.error("Error fetching telecallers:", error);
    }
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);

    const filtered = employees.filter(
      (employee) =>
        (employee.Employee_Name &&
          employee.Employee_Name.toLowerCase().includes(searchValue)) ||
        (employee.Email && employee.Email.toLowerCase().includes(searchValue))
    );

    setFilteredEmployees(filtered);
  };

  const handleTelecallerChange = (e, empId) => {
    setTelecallers({ ...telecallers, [empId]: e.target.value });
  };

  // const handleStatusChange = async (employee) => {
  //   const currentStatus = employee.Status || "Pending";
  //   const newStatus = currentStatus === "Pending" ? "Assigned" : "Pending";
  //   console.log("New Status:", newStatus);

  //   const telecallerId = telecallers[employee.id] || "";
  //   const selectedTelecaller = telecallerOptions.find(
  //     (t) => t.id === Number(telecallerId)
  //   );
  //   const telecallerName = selectedTelecaller ? selectedTelecaller.name : "";

  //   try {
  //     const response = await axios.post(`${url.path}/updateMembershipStatus/`, {
  //       employeeId: employee.id,
  //       status: newStatus,
  //       telecallerId: telecallerId,
  //       telecallerName: telecallerName,
  //     });

  //     const updatedStatus = response.data?.data?.[0]?.Status || newStatus;

  //     setEmployees((prevEmployees) =>
  //       prevEmployees.map((emp) =>
  //         emp.id === employee.id ? { ...emp, Status: updatedStatus } : emp
  //       )
  //     );

  //     setFilteredEmployees((prevEmployees) =>
  //       prevEmployees.map((emp) =>
  //         emp.id === employee.id ? { ...emp, Status: updatedStatus } : emp
  //       )
  //     );
  //   } catch (error) {
  //     console.error("Error updating status:", error);
  //   }
  //   fetchEmployees(`${url.path}/premiumManageremployees/`);
  // };

  const handleStatusChange = async (employee) => {
    const currentStatus = employee.Status || "Pending";
    const newStatus = currentStatus === "Pending" ? "Assigned" : "Pending";
    console.log("New Status:", newStatus);
  
    const telecallerId = telecallers[employee.id] || employee.Telecaller || "";
  
    if (!telecallerId) {
      alert("Please select a telecaller before assigning!");
      return;
    }
  
    const selectedTelecaller = telecallerOptions.find(
      (t) => t.id === Number(telecallerId)
    );
    const telecallerName = selectedTelecaller ? selectedTelecaller.name : "";
  
    try {
      const response = await axios.post(`${url.path}/updateMembershipStatus/`, {
        employeeId: employee.id,
        status: newStatus,
        telecallerId: telecallerId,
        telecallerName: telecallerName,
      });
  
      const updatedStatus = response.data?.data?.[0]?.Status || newStatus;
  
      setEmployees((prevEmployees) =>
        prevEmployees.map((emp) =>
          emp.id === employee.id ? { ...emp, Status: updatedStatus } : emp
        )
      );
  
      setFilteredEmployees((prevEmployees) =>
        prevEmployees.map((emp) =>
          emp.id === employee.id ? { ...emp, Status: updatedStatus } : emp
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
    
    fetchEmployees(`${url.path}/premiumManageremployees/`);
  };
  

  return (
    <>
      <Navbar />
      <center>
        <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>
          Premium Membership
        </h3>
      </center>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Search by name, email, or contact..."
          className="search-input"
          style={{
            width: "250px",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            textAlign: "center",
          }}
        />
      </div>

      <div className="table-container">
        <table className="responsive-table" id="productstable">
          <thead className="bg-gray-200">
            <tr>
              <th className="border border-gray-300 px-4 py-2">Name</th>
              <th className="border border-gray-300 px-4 py-2">Email</th>
              <th className="border border-gray-300 px-4 py-2">
                Package Taken
              </th>
              <th className="border border-gray-300 px-4 py-2">Telecaller</th>
              <th className="border border-gray-300 px-4 py-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredEmployees.length > 0 ? (
              filteredEmployees.map((employee) => (
                <tr key={employee.id || employee.Email} className="bg-white">
                  <td className="border border-gray-300 px-4 py-2">
                    {employee.Employee_Name || "N/A"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {employee.Email || "N/A"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {employee.PackageTaken || "N/A"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    <select
                      // value={employee.Telecaller || ""}
                      value={
                        telecallers[employee.id] || employee.Telecaller || ""
                      }
                      onChange={(e) => handleTelecallerChange(e, employee.id)}
                      className="border px-2 py-1 rounded"
                    >
                      <option value="">Select Telecaller</option>
                      {telecallerOptions.map((telecaller) => (
                        <option key={telecaller.id} value={telecaller.id}>
                          {telecaller.name}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td className="border border-gray-300 px-4 py-2">
                    <button
                      onClick={() => handleStatusChange(employee)}
                      disabled={
                        employee.Status === "Assigned" ||
                        employee.Status === "Approved"
                      }
                      // disabled={employee.Status === "Assigned" || "Approved"}
                      className={`px-4 py-2 text-white rounded ${
                        employee.Status === "Assigned"
                          ? "bg-green-500 hover:bg-green-700"
                          : "bg-yellow-500 hover:bg-yellow-700"
                      }`}
                    >
                      {employee.Status || "Pending"}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4">
                  No employees found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default PremiumMembershipManagerEmployee;
